import { useState } from "react";
import Label from "../../components/Label";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { FormModalControlled } from "../../components/Modal";

const ConstantsBlock = ({ constants, onChange }) => {
  const [ivsModalOpen, setIvsModalOpen] = useState(false);
  const [ivsId, setIvsId] = useState("");
  const [ivsLoading, setIvsLoading] = useState(false);
  const [ivsLinked, setIvsLinked] = useState(false);

  const handleIvsSubmit = () => {
    if (!ivsId.trim()) return;
    setIvsLoading(true);
    setIvsModalOpen(false);

    setTimeout(() => {
      onChange({ id: "PRICE_PER_CM", value: "4" });
      setIvsLoading(false);
      setIvsLinked(true);
    }, 5000);
  };

  const handleIvsClose = () => {
    setIvsModalOpen(false);
    setIvsId("");
  };

  const handleUnlink = () => {
    setIvsLinked(false);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--gap)",
      }}
    >
      {constants?.map((constant) => {
        const isPrice = constant.id === "PRICE_PER_CM";
        const isDisabled = isPrice && (ivsLoading || ivsLinked);

        return (
          <div
            key={constant.id}
            style={{ display: "flex", alignItems: "center" }}
          >
            <div style={{ width: "var(--width-32)" }}>
              <Label>{constant.label}</Label>
            </div>
            <div style={{ width: "var(--width-32)" }}>
              <Input
                type="number"
                value={constant.value}
                onChange={(e) =>
                  onChange({ id: constant.id, value: e.currentTarget.value })
                }
                disabled={isDisabled}
              />
            </div>
            <div style={{ marginLeft: "var(--gap)" }}>
              {constant.id === "BASE_WIDTH" ? "cm" : "EUR"}
            </div>
            {isPrice && (
              <div style={{ marginLeft: "var(--gap)" }}>
                {ivsLoading ? (
                  <span style={{ opacity: 0.6 }}>Kraunama...</span>
                ) : ivsLinked ? (
                  <Button inline icon="pencil" onClick={handleUnlink}>
                    Redaguoti
                  </Button>
                ) : (
                  <Button
                    inline
                    icon="download"
                    onClick={() => {
                      setIvsId("");
                      setIvsModalOpen(true);
                    }}
                  >
                    Pasiimti iš IVS
                  </Button>
                )}
              </div>
            )}
          </div>
        );
      })}

      <FormModalControlled
        isOpen={ivsModalOpen}
        onClose={handleIvsClose}
        onCancel={handleIvsClose}
        onSubmit={handleIvsSubmit}
        submitLabel="Gerai"
        cancelLabel="Atšaukti"
        disabled={!ivsId.trim()}
      >
        <h2>Pasiimti iš IVS</h2>
        <div style={{ margin: "var(--gap) 0", minWidth: "min(400px, 80vw)" }}>
          <Input
            label="ID IVS viduje"
            value={ivsId}
            onChange={(e) => setIvsId(e.target.value)}
            placeholder=""
          />
        </div>
      </FormModalControlled>
    </div>
  );
};

export default ConstantsBlock;
